module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image15.3ee8dd1a.webp";